import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material.module';
import { LayoutModule } from './layout/layout/layout.module';

import { HttpClientModule } from '@angular/common/http';
import { httpInterceptorProviders } from './interceptors';
import { SettingsModule } from './components/settings/settings.module';
import { TokenGuard } from './guards/token.guard';
import { TokenComponent } from './components/token/token.component';
import { ToastrModule } from 'ngx-toastr';
import { SlugPageComponent } from './components/slugPage/slug-page.component';
import { DatePipe } from '@angular/common';
import { AdminSetariModule } from './platform/nomenclatoare/admin-setari/admin-setari.module';
import { CerereSabloaneModule } from './components/sabloane/cerere-sabloane.module';
import { ProgramariModule } from './components/programari/programari.module';
import { PlatiModule } from './components/plati/plati.module';
import { CereriModule } from './components/cereri/cereri.module';
import { ProgramariViewModule } from './components/programari-view/programari-view.module';
import { PublicatiiCasatoriiModule } from './components/publicatii-casatorii/publicatii-casatorii.module';

@NgModule({
    declarations: [
        AppComponent, TokenComponent, SlugPageComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        MaterialModule,
        SettingsModule,
        HttpClientModule,
        AdminSetariModule,
        CerereSabloaneModule,
        ProgramariModule,
        PlatiModule,
        CereriModule,
        ProgramariViewModule,
        PublicatiiCasatoriiModule,
        ToastrModule.forRoot(),
    ],
    providers: [httpInterceptorProviders, TokenGuard, DatePipe],
    bootstrap: [AppComponent]
})
export class AppModule { }
